import { Lock, X } from 'lucide-react'
import { useSettingsStore } from '@/core/storage/zustand-store'
import { Button } from '../shadcn/button'

export function PrivacyBanner() {
  const dismissed = useSettingsStore((s) => s.settings.privacyBannerDismissed)
  const patch = useSettingsStore((s) => s.patch)

  if (dismissed) return null

  return (
    <div
      role="region"
      aria-label="Aviso de privacidade"
      className="border-b border-border bg-muted/40"
    >
      <div className="container flex items-center justify-between gap-4 py-2.5 text-[12px]">
        <p className="flex items-center gap-2 leading-relaxed">
          <Lock className="h-3.5 w-3.5 text-muted-foreground" />
          <span>
            Seus dados ficam <strong className="font-semibold">somente neste navegador</strong>.
            Nenhum servidor, nenhuma telemetria. Exporte regularmente.
          </span>
        </p>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => patch({ privacyBannerDismissed: true })}
          className="h-7 text-[11px]"
        >
          <X className="h-3 w-3" />
          Entendi
        </Button>
      </div>
    </div>
  )
}
